<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
            class="query-form" @submit.native.prevent>
            <el-form-item label="搜索">
                <el-input v-model="queryForm.name" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoVideoList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addVideoVideo">新建运费模板</el-button>
                    <el-button type="warning" plain size="small" icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1" @click="editVideoVideo(null)">修改</el-button>
                    <el-button type="danger" plain size="small" icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0" @click="deleteVideoVideo(null)">删除</el-button>
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshVideoVideoList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="videoVideoList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
                @selection-change="handleSelectionChange" size="samll">
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="id" label="id" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="name" label="模板名称" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="type" label="计费方式" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="appoint" label="指定包邮" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="sort" label="排序" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="add_time" label="添加时间" width="180">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="300">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkVideoVideo(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editVideoVideo(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteVideoVideo(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum" background :pager-count="7">
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="videoVideoStates[videoVideoState]" :visible.sync="showDialog" width="70%"
                @close="closeDialog">
                <div>
                    <el-form :model="videoVideo" ref="videoVideoForm" :rules="rules" label-width="140px" size="small">
                        <el-form-item label="模板名称" prop="name">
                            <el-input size="small" style="width: 80%;" v-model="videoVideo.name"
                                :disabled="videoVideoState == 'check'" placeholder="请输入模板名称"></el-input>
                        </el-form-item>
                        <el-form-item label="计费方式" prop="type">
                            <el-radio-group v-model="videoVideo.type">
                                <el-radio :label="0">按件数</el-radio>
                                <el-radio :label="1">按重量</el-radio>
                                <el-radio :label="2">按体积</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="配送区域及运费" prop="regionInfo">
                            <el-table :data="videoVideo.regionInfo" style="width: 98%" size="small">
                                <el-table-column prop="placeName" label="可配送区域" width="175">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.placeName" placeholder="请输入内容" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="first" :label="'首件'+(videoVideo.type == 1 ? '重量(KG)' : (videoVideo.type == 2 ? '体积(m³)' : ''))" width="175">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.first" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="price" label="运费(元)" width="174">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.price" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="continue" :label="'续件'+(videoVideo.type == 1 ? '重量(KG)' : (videoVideo.type == 2 ? '体积(m³)' : ''))" width="175">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.continue" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="continuePrice" label="续费(元)" width="174">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.continuePrice" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="操作" width="98">
                                    <template slot-scope="scop">
                                        <div class="operation" v-show="scop.row.placeName != '默认全国'">
                                            <div @click="deleteData(scop.row.placeName,'regionInfo')">
                                                <i class="el-icon-delete-solid"></i>
                                                <span class="operation-label">删除</span>
                                            </div>
                                        </div>
                                    </template>
                                    </el-table-column>
                            </el-table>
                            <ShippingAddress @address="regionInfo" title="添加配送区域"></ShippingAddress>
                            <!-- <el-button type="primary">添加配送区域</el-button> -->
                        </el-form-item>
                        <el-form-item label="指定包邮" prop="appoint">
                            <el-radio-group v-model="videoVideo.appoint">
                                <el-radio :label="1">开启</el-radio>
                                <el-radio :label="0">关闭</el-radio>
                            </el-radio-group>
                            <template v-if="videoVideo.appoint == 1">
                                <el-table :data="videoVideo.appointInfo" style="width: 98%" size="small">
                                <el-table-column prop="placeName" label="配送区域">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.placeName" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="aNum" :label="'包邮'+(videoVideo.type == 1 ? '重量' : (videoVideo.type == 2 ? '体积(m³)' : '件数'))">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.aNum" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="aPrice" label="包邮金额(元)">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.aPrice" style="width: 120px;"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="操作" width="98">
                                    <template slot-scope="scop">
                                        <div class="operation">
                                            <div @click="deleteData(scop.row.placeName,'appointInfo')">
                                                <i class="el-icon-delete-solid"></i>
                                                <span class="operation-label">删除</span>
                                            </div>
                                        </div>
                                    </template>
                                    </el-table-column>
                                </el-table>
                                <!-- <el-button type="primary">添加包邮区域</el-button> -->
                                <ShippingAddress @address="appointInfo" title="添加包邮区域"></ShippingAddress>
                                </template>
                        </el-form-item>
                        <el-form-item label="指定不送达" prop="noDelivery">
                            <el-radio-group v-model="videoVideo.noDelivery">
                                <el-radio :label="1">开启</el-radio>
                                <el-radio :label="0">关闭</el-radio>
                            </el-radio-group>
                            <template v-if="videoVideo.noDelivery == 1">
                                <el-table :data="videoVideo.noDeliveryInfo" style="width: 98%" size="small">
                                <el-table-column prop="placeName" label="选择区域">
                                    <template slot-scope="scop">
                                        <el-input v-model="scop.row.placeName"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="操作"  width="98">
                                    <template slot-scope="scop">
                                        <div class="operation">
                                            <div @click="deleteData(scop.row.placeName,'noDeliveryInfo')">
                                                <i class="el-icon-delete-solid"></i>
                                                <span class="operation-label">删除</span>
                                            </div>
                                        </div>
                                    </template>
                                    </el-table-column>
                                </el-table>
                                <!-- <el-button type="primary">添加不送达区域</el-button> -->
                                <ShippingAddress title="添加不送达区域" @address="noDeliveryInfo"></ShippingAddress>
                                </template>
                        </el-form-item>
                        <el-form-item label="排序" prop="sort">
                            <el-input size="small" style="width: 140px;" v-model="videoVideo.sort"
                                :disabled="videoVideoState == 'check'" placeholder="输入值越大越靠前"></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="videoVideoState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
  
<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ShippingAddress from "@/components/system/ShippingAddress.vue"

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ShippingAddress
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetVideoVideoList();
                this.getVideoVideoList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetVideoVideoList();
                this.getVideoVideoList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                name:""
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            videoVideoState: 'add',
            videoVideoStates: {
                add: '新建运费模板',
                check: '查看运费模板',
                edit: '修改运费模板'
            },

            multipleSelection: [],
            videoVideoList: [],
            videoVideo: {
                name: "",// 模板名称
                type: 0,// 类型
                appoint: 0,// 包邮
                appointInfo: [], // 包邮地址
                noDelivery: 0,// 不送达
                noDeliveryInfo: [],// 不送达
                regionInfo: [{
                    continue: 1,
                    continuePrice: 0,
                    first: 1,
                    price: 0,
                    region:[{
                        name: "默认全国", 
                        cityId: 0
                    }],
                    placeName: "默认全国"
                }], // 派送地址范围
                sort: 0,// 排序
            },
            btnLoading: false,

            rules: {
                name: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getVideoVideoList();
    },
    methods: {
        // 删除数据
        deleteData(name,sign){
            for (const key in this.videoVideo[sign]) {
                if(this.videoVideo[sign][key].placeName == name){
                    this.videoVideo[sign].splice(key, 1);
                }
                console.log(this.videoVideo[sign][key].placeName,name)
            }
            console.log(this.videoVideo[sign],sign)
        },
        // 派送区域及运费
        regionInfo(arr,placeName){
            this.videoVideo.regionInfo.push({
                    continue: 1,
                    continuePrice: 0,
                    first: 1,
                    price: 0,
                    region: arr,
                    placeName
                })
        },
        // 包邮
        appointInfo(arr,placeName){
            this.videoVideo.appointInfo.push({
                aNum: "1",
                aPrice: 0,
                place: arr,
                placeName: placeName
            })
        },
        // 添加不送达区域
        noDeliveryInfo(arr,placeName){
            this.videoVideo.noDeliveryInfo.push({
                    place: arr,
                    placeName: placeName
                })
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetVideoVideoList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.videoVideoList = [];
        },
        resetDialog() {
            this.videoVideoState = 'add';
            this.showDialog = false;
            this.queryForm = {
                name:""
            };
            this.getVideoVideoList();
        },
        closeDialog() {
            this.showDialog = false
            this.videoVideo = {
                name: "",// 模板名称
                type: 0,// 计费方式
                appoint: 0,// 是否包邮（0：否，1：是）
                appointInfo: [], // 包邮地址
                noDelivery: 0,// 是否不送达（0：否，1：是）
                noDeliveryInfo: [],// 不送达（0：否，1：是）
                regionInfo: [{
                    continue: 1,
                    continuePrice: 0,
                    first: 1,
                    price: 0,
                    region:[{
                        name: "默认全国", 
                        cityId: 0
                    }],
                    placeName: "默认全国"
                }], // 派送地址范围
                sort: 0,// 排序
            };
        },
        submitForm() {
            console.log(JSON.parse(JSON.stringify({ ...this.videoVideo })))
            if (this.videoVideoState == 'add') {
                this.$refs.videoVideoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/videovideo/add`, { ...this.videoVideo }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetVideoVideoList();
                                this.resetDialog();
                                this.getVideoVideoList();
                            }
                        });
                    }
                });
            } else if (this.videoVideoState == 'edit') {
                this.$refs.videoVideoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/videovideo/edit`, { ...this.videoVideo }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoVideoList();
                                this.resetDialog();
                                this.getVideoVideoList();
                            }
                        });
                    }
                });
            }
        },
        addVideoVideo() {
            this.showDialog = true;
            this.videoVideoState = 'add';
        },
        checkVideoVideo(videoVideoId) {
            console.log(videoVideoId);
            this.currentVideoVideoId = videoVideoId;

            this.getVideoVideoById();
            this.showDialog = true;
            this.videoVideoState = 'check';
        },
        editVideoVideo(videoVideoId) {
            console.log('videoVideo', videoVideoId);
            if (videoVideoId) {
                this.currentVideoVideoId = videoVideoId;
                this.getVideoVideoById();
            } else {
                this.videoVideo = { ...this.videoVideo, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.videoVideoState = 'edit';
        },
        deleteVideoVideo(videoVideoId) {
            let ids = '';
            if (videoVideoId) {
                ids = videoVideoId;
            } else {
                ids = this.multipleSelection.map((videoVideo) => videoVideo.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/videovideo/delete`, { ids }).then((res) => {
                        if (res.success || res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetVideoVideoList();
                            this.getVideoVideoList();
                        }
                    });
                })
                .catch(() => { });
        },
        refreshVideoVideoList() {
            this.resetVideoVideoList();
            this.getVideoVideoList();
        },
        getVideoVideoList(query = {}) {
            this.loading = true;
            get(`/mpp/videovideo/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success || res.code == 200) {
                    this.videoVideoList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getVideoVideoById() {
            get(`/mpp/videovideo/get`, { id: this.currentVideoVideoId }).then((res) => {
                if (res.success || res.code == 200) {
                    this.videoVideo = { ...this.videoVideo, ...res.videoVideo };
                }
            });
        },
        /**
         * 导出信息
         */
        exportVideoVideoList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/videovideo/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/videovideo/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/videovideo/importData`, formData);
            this.refreshVideoVideoList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getVideoVideoList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getVideoVideoList();
        }
    }

};
</script>
  
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    &>div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>